"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var CheckResponse_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckResponse = void 0;
const class_validator_jsonschema_1 = require("class-validator-jsonschema");
const class_validator_1 = require("class-validator");
const check_output_1 = require("./../output/check.output");
const standard_response_1 = require("../../commons/responses/standard.response");
const status_enum_1 = require("../../commons/responses/status.enum");
let CheckResponse = CheckResponse_1 = class CheckResponse extends standard_response_1.StandardResponse {
    constructor(status, data, message) {
        super(status, data, message);
        this.data = data;
    }
    static gen(data) {
        return new CheckResponse_1(status_enum_1.Status.success, data);
    }
};
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", check_output_1.CheckOutput)
], CheckResponse.prototype, "data", void 0);
CheckResponse = CheckResponse_1 = __decorate([
    (0, class_validator_jsonschema_1.JSONSchema)({ description: 'Contains a boolean describing token validity' }),
    __metadata("design:paramtypes", [String, check_output_1.CheckOutput, String])
], CheckResponse);
exports.CheckResponse = CheckResponse;
